export const globalSearchQueryKeys = {
  GET_PINS: 'getPins',
  GET_TASKS: 'getTasks',
  GET_PLANS: 'getPlans'
}
